import { toast } from '@lionstep/ui';

// Api
import {
  getDashboardJobsApi,
  deleteJobApi,
  updateJobStatusApi,
  sendJobStatusChangedEmailApi,
} from '../../../../api/job.api';

// Types
import * as types from '../types/dashboard.types';

// Actions

// Config
import { ENV } from '../../../../config';

// Constants
import { JOB_ARCHIVED_STATUSES, PAGE_SIZE } from '../../dashboard.constants';

export const getJobs =
  ({ offset, archived, user = undefined }) =>
  async (dispatch) => {
    try {
      dispatch({ type: types.GET_JOBS_START });

      const { data: response } = await getDashboardJobsApi({
        params: {
          limit: PAGE_SIZE,
          offset,
          archived: archived === 'true' ? 'true' : 'false',
          user,
        },
      });

      dispatch({
        type: types.GET_JOBS_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({ type: types.GET_JOBS_FAIL });
    }
  };

export const deleteJob =
  ({ id }) =>
  async (dispatch) => {
    try {
      dispatch({ type: types.DELETE_JOB_START });

      await deleteJobApi({ id });

      dispatch({ type: types.DELETE_JOB_SUCCESS });
      toast.success('Job deleted', {
        id: types.DELETE_JOB_SUCCESS,
      });
    } catch (error) {
      dispatch({ type: types.DELETE_JOB_FAIL });
      toast.error('Error deleting job', {
        id: types.DELETE_JOB_FAIL,
        statusCode: error?.response?.status,
      });
    }
  };

const sendJobArchivedStatusChangedEmail =
  ({ id, title, status, user }) =>
  async () => {
    try {
      const emailPayload = {
        newStatusField: status,
        jobTitle: title,
        jobId: id,
        company: user.company_name,
        companyId: user.company_id,
        userName: user.display_name,
        userEmail: user.email,
      };

      await sendJobStatusChangedEmailApi({ data: emailPayload });
    } catch (error) {
      toast.error('Error sending email for archived job', {
        id: 'SEND_ARCHIVED_EMAIL',
        statusCode: error?.response?.status,
      });
    }
  };

export const archiveJob =
  ({ id, title, user }) =>
  async (dispatch) => {
    try {
      dispatch({ type: types.ARCHIVE_JOB_START });

      await updateJobStatusApi({
        id,
        data: { status: JOB_ARCHIVED_STATUSES.archived },
      });

      if (ENV !== 'development') {
        dispatch(
          sendJobArchivedStatusChangedEmail({
            id,
            title,
            status: JOB_ARCHIVED_STATUSES.archived,
            user,
          }),
        );
      }

      dispatch({ type: types.ARCHIVE_JOB_SUCCESS });
      toast.success('Job archived', {
        id: types.ARCHIVE_JOB_SUCCESS,
      });
    } catch (error) {
      dispatch({ type: types.ARCHIVE_JOB_FAIL });
      toast.error('Error archiving job', {
        id: types.ARCHIVE_JOB_FAIL,
        statusCode: error?.response?.status,
      });
    }
  };

export const publishJob =
  ({ id, title, user }) =>
  async (dispatch) => {
    try {
      dispatch({ type: types.PUBLISH_JOB_START });

      await updateJobStatusApi({
        id,
        data: { status: JOB_ARCHIVED_STATUSES.published },
      });

      if (ENV !== 'development') {
        dispatch(
          sendJobArchivedStatusChangedEmail({
            id,
            title,
            status: JOB_ARCHIVED_STATUSES.published,
            user,
          }),
        );
      }

      dispatch({ type: types.PUBLISH_JOB_SUCCESS });
      toast.success('Job published', {
        id: types.PUBLISH_JOB_SUCCESS,
      });
    } catch (error) {
      dispatch({ type: types.PUBLISH_JOB_FAIL });
      toast.error('Error publishing job', {
        id: types.PUBLISH_JOB_FAIL,
        statusCode: error?.response?.status,
      });
    }
  };

/**
 * JOB ACTIONS MODAL
 */
export const openJobActionModal = ({ modalType, job }) => ({
  type: types.OPEN_JOB_ACTION_MODAL,
  payload: { modalType, job },
});

export const closeJobActionModal = () => ({
  type: types.CLOSE_JOB_ACTION_MODAL,
});

export const resetDashboardStore = () => ({
  type: types.RESET_DASHBOARD_STORE,
});
